import {
  connect,
  MapDispatchToProps,
  MapStateToPropsFactory,
} from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType, JournalFilterType } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';
import { createGetDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './Journals';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

type StateProps = Pick<
  Props,
  | 'streamId'
  | 'featuredStreamId'
  | 'journals'
  | 'featuredJournals'
  | 'hasMoreJournals'
  | 'isFetchingJournals'
>;

type DispatchProps = Pick<Props, 'fetchMoreJournals'>;

type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToPropsFactory: MapStateToPropsFactory<
  StateProps,
  OwnProps,
  AppState
> = () => {
  const getJournalsByIds = createGetDeviationsByIds();
  const getFeaturedJournalsByIds = createGetDeviationsByIds();

  return (state, ownProps) => {
    const journalsStreamId = getPostsDeviationsStreamId({
      type: PostsType.JOURNALS,
      sortOrder: ownProps.sortOrder,
    });
    const featuredJournalsStreamId = getPostsDeviationsStreamId({
      type: PostsType.JOURNALS,
      filter: JournalFilterType.FEATURED,
    });
    const journals = getJournalsByIds(
      state,
      streamSelectors.getItems(state, journalsStreamId)
    );

    const featuredJournals = getFeaturedJournalsByIds(
      state,
      streamSelectors.getItems(state, featuredJournalsStreamId)
    );

    return {
      streamId: journalsStreamId,
      featuredStreamId: featuredJournalsStreamId,
      journals,
      featuredJournals,
      hasMoreJournals: streamSelectors.hasMore(state, journalsStreamId),
      hasMoreFeaturedJournals: streamSelectors.hasMore(
        state,
        featuredJournalsStreamId
      ),
      isFetchingJournals: streamSelectors.isFetching(state, journalsStreamId),
      isFetchingFeaturedJournals: streamSelectors.isFetching(
        state,
        featuredJournalsStreamId
      ),
    };
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => {
  const journalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    sortOrder: ownProps.sortOrder,
  });
  const featuredJournalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    filter: JournalFilterType.FEATURED,
  });
  return {
    fetchMoreJournals: () =>
      dispatch(withOffset.actions.fetch(journalsStreamId)),
    fetchMoreFeaturedJournals: () =>
      dispatch(withOffset.actions.fetch(featuredJournalsStreamId)),
  };
};

export default connect(mapStateToPropsFactory, mapDispatchToProps);
